// FASE 11 (Luglio 2026): Rimosso @ts-nocheck
/**
 * i18n/config.ts — RideConnect Internationalization
 *
 * FASE 3.5: Supporto completo 5 lingue EU (IT, EN, DE, FR, ES).
 * Le traduzioni sono lazy-loaded per non impattare il bundle iniziale.
 */

import i18n from "i18next";
import * as ReactI18next from "react-i18next";
const initReactI18next = (ReactI18next as any).initReactI18next;

// ─── Traduzioni inline per evitare HTTP fetch (incluse nel bundle) ──────────
import en from "./locales/en.json";
import it from "./locales/it.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    it: { translation: it },
    de: { translation: de },
    fr: { translation: fr },
    es: { translation: es },
  },
  lng: "it", // default italiano
  fallbackLng: "it",
  interpolation: {
    escapeValue: false, // React già gestisce XSS
  },
  returnObjects: false,
});

/** Lingue supportate */
export const SUPPORTED_LANGUAGES = [
  { code: "it", label: "Italiano" },
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Français" },
  { code: "es", label: "Español" },
] as const;

export default i18n;
